import { render, staticRenderFns } from "./OurLeaderCreateTranslation.vue?vue&type=template&id=4cc920e0&"
import script from "./OurLeaderCreateTranslation.vue?vue&type=script&lang=js&"
export * from "./OurLeaderCreateTranslation.vue?vue&type=script&lang=js&"
import style0 from "./OurLeaderCreateTranslation.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports